<template>
  <div class="toast-stack-container fixed top-16 inset-x-0 z-50 flex flex-col items-center pointer-events-none px-4 gap-2">
    <transition-group name="toast">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="toast-item pointer-events-auto flex items-center justify-between gap-3 px-4 py-2.5 rounded-xl border shadow-lg text-sm max-w-md w-full transition"
        :class="{
          'bg-blue-50 border-blue-200 text-blue-900 dark:bg-blue-950 dark:border-blue-800 dark:text-blue-100': toast.type === 'info',
          'bg-emerald-50 border-emerald-200 text-emerald-900 dark:bg-emerald-950 dark:border-emerald-800 dark:text-emerald-100': toast.type === 'success',
          'bg-amber-50 border-amber-200 text-amber-900 dark:bg-amber-950 dark:border-amber-800 dark:text-amber-100': toast.type === 'warning',
          'bg-red-50 border-red-200 text-red-900 dark:bg-red-950 dark:border-red-800 dark:text-red-100': toast.type === 'error',
        }"
      >
        <div class="flex items-center gap-2 min-w-0">
          <i
            class="text-base shrink-0"
            :class="{
              'fa-solid fa-spinner fa-spin text-blue-600': toast.text.includes('🔄') || toast.text.includes('Working'),
              'fa-solid fa-circle-check text-emerald-600': toast.type === 'success',
              'fa-solid fa-circle-exclamation text-amber-600': toast.type === 'warning',
              'fa-solid fa-circle-xmark text-red-600': toast.type === 'error',
              'fa-solid fa-circle-info text-blue-600': toast.type === 'info' && !toast.text.includes('🔄'),
            }"
          ></i>
          <span class="truncate font-medium">{{ toast.text }}</span>
        </div>

        <button
          type="button"
          class="shrink-0 p-1 opacity-60 hover:opacity-100 transition"
          @click="$emit('dismiss', toast.id)"
        >
          <i class="fa-solid fa-xmark text-xs"></i>
        </button>
      </div>
    </transition-group>
  </div>
</template>

<script setup lang="ts">
import type { ToastAlert } from '../types';

defineProps<{
  toasts: ToastAlert[];
}>();

defineEmits<{
  dismiss: [id: string];
}>();
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}
.toast-enter-from {
  opacity: 0;
  transform: translateY(-16px) scale(0.95);
}
.toast-leave-to {
  opacity: 0;
  transform: translateY(-8px) scale(0.95);
}
</style>
